import { format, parseISO } from 'date-fns';
import React, { useEffect, useState } from 'react';

import { Container } from './styles';
import api from '~/services/api';
import { formatPrice } from '~/utils/format';

interface ITotals {
  total_loan: number;
  total_repaid: number;
  total_to_repay: number;
  monthly_payments: number;
  next_payment_date: string;
}

const Totalizers: React.FC = () => {
  const [totalLoan, setTotalLoan] = useState('-');
  const [totalRepaid, setTotalRepaid] = useState('-');
  const [totalToRepay, setTotalToRepay] = useState('-');
  const [monthlyPayments, setMonthlyPayments] = useState('-');
  const [nextPaymentDate, setNextPaymentDate] = useState('-');

  useEffect(() => {
    api.get<ITotals>('contracts/totals').then((response) => {
      setTotalLoan(formatPrice(response.data.total_loan).replace('$', ''));
      setTotalRepaid(formatPrice(response.data.total_repaid).replace('$', ''));
      setTotalToRepay(
        formatPrice(response.data.total_to_repay).replace('$', '')
      );
      setMonthlyPayments(
        formatPrice(response.data.monthly_payments).replace('$', '')
      );
      setNextPaymentDate(
        format(parseISO(response.data.next_payment_date), 'MM/dd/yy')
      );
    });
  }, []);

  return (
    <Container className="d-lg-flex justify-content-between mb-lg-4">
      <div>
        <span>Total Loan</span>
        <p>{totalLoan}</p>
      </div>
      <div>
        <span>Total Repaid</span>
        <p>{totalRepaid}</p>
      </div>
      <div>
        <span>Total To Repay</span>
        <p>{totalToRepay}</p>
      </div>
      <div>
        <span>Monthly Payments</span>
        <p>{monthlyPayments}</p>
      </div>
      <div>
        <span>Next Payment Date</span>
        <p className="fw-normal">{nextPaymentDate}</p>
      </div>
    </Container>
  );
};

export default Totalizers;
